import VisionStatement from "../components/about/VisionStatement";
import GlobalStats from "../components/global/GlobalStats";

const Vision = () => {
  return (
    <div className="page-container">
      <VisionStatement />
      <GlobalStats />
    </div>
  );
};

export default Vision;